__turbopack_context__.v({
  "bubbleContent": "FriendIconShared-module__-l6iXG__bubbleContent",
  "empty": "FriendIconShared-module__-l6iXG__empty",
  "hackSmallerFont": "FriendIconShared-module__-l6iXG__hackSmallerFont",
  "playerStatusActive": "FriendIconShared-module__-l6iXG__playerStatusActive",
  "playerStatusInactive": "FriendIconShared-module__-l6iXG__playerStatusInactive",
  "playerStatusLeaving": "FriendIconShared-module__-l6iXG__playerStatusLeaving",
});
